module.exports = __webpack_public_path__ + "img/sidebar-battery-8.cdefdd0a.svg";